module.exports = "<select class=form-control name=poi_version ng-model=$ctrl.selectedVersion ng-options=\"version.value as version.label for version in $ctrl.versionsList\"> </select> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/versionslist/partial.html
// module id = 566
// module chunks = 0